import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  get(params) {
    const url = apiRoutes.apiV1SignUrlPath();

    return FetchHelpers.get(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/SignedUrlRepository.js